var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 30,
    viewBox: "0 0 97 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.336 21.7243C64.2924 21.0873 62.5925 20.0571 61.9946 19.7368C57.4994 23.4777 54.3824 20.3284 54.3242 18.253H66.7668C66.8478 17.7797 66.8907 17.2937 66.8907 16.7976C66.8907 11.9753 62.898 8.06592 57.9729 8.06592C53.0477 8.06592 49.055 11.9753 49.055 16.7976C49.055 21.6201 53.0477 25.5296 57.9729 25.5296C61.0313 25.5296 63.7297 24.0218 65.336 21.7243ZM54.3241 14.943C54.5287 13.1517 56.091 11.747 57.9728 11.747C59.8544 11.747 61.4167 13.1517 61.6213 14.943H54.3241ZM40.9751 17.6309L44.5146 8.6771H50.0954L42.8061 24.9819H39.144L31.8548 8.6771H37.4356L40.9751 17.6309ZM76.7321 8.35665C76.6412 8.36546 76.5488 8.37527 76.4537 8.38778C74.378 8.66006 73.2007 9.95546 73.2007 9.95546L72.6243 8.67712H68.3319V24.9819H73.3619V17.5187V17.3075L73.3623 17.2867C73.376 16.606 73.4113 14.8414 75.2691 13.5943C76.489 12.7753 77.8808 12.897 78.8945 13.1763L76.7321 8.35665ZM87.88 17.6309L91.4195 8.6771H97.0003L89.7111 24.9819H86.049L78.7598 8.6771H84.3406L87.88 17.6309Z",
    fill: "#15153A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2575 20.5055C11.3941 22.9186 11.0331 27.1126 13.4003 29.9651L24.5854 20.5523C27.4489 18.1394 27.8099 13.9452 25.4424 11.0928L14.2575 20.5055Z",
    fill: "url(#paint0_linear_61_2318)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.874 0L8.15047 14.0876C5.28709 16.5007 4.92609 20.6947 7.29345 23.5472L9.67038 26.2499C9.64105 25.7984 9.64482 25.3423 9.68592 24.8841C9.89444 22.5448 11.0108 20.4125 12.8301 18.8794L24.0168 9.45952C26.8803 7.04644 27.2413 2.85242 24.874 0Z",
    fill: "url(#paint1_linear_61_2318)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41672 7.56888C0.817966 8.91603 -0.000580529 10.8185 3.08904e-07 12.7326V12.7364C0.0013072 14.2495 0.514768 15.7695 1.55955 17.0284L3.64476 19.3995C3.64447 19.1327 3.65478 18.8648 3.67874 18.5961C3.88784 16.2531 5.00596 14.1175 6.82732 12.5826L10.0324 9.88272C12.8339 7.4611 13.174 3.31272 10.8254 0.48291L2.41672 7.56888Z",
    fill: "url(#paint2_linear_61_2318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_2318",
    x1: 27.0021,
    y1: 11.0928,
    x2: 11.8409,
    y2: 11.0928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_2318",
    x1: 26.4335,
    y1: 0,
    x2: 5.73389,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_2318",
    x1: 12.3835,
    y1: 0.48291,
    x2: 0,
    y2: 0.48291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333399"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7d5a4dbf9555ad96cc55febb7fd25c67.svg";
export { ForwardRef as ReactComponent };